var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4785 12.2689H24.0002C24.0002 11.1858 23.8559 10.1365 23.5868 9.13843H11.4785V12.2689Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4785 6.00716H22.239C21.5044 4.80847 20.5651 3.74896 19.47 2.87671H11.4785V6.00716Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 24.2666C14.8252 24.2666 17.421 23.2905 19.4709 21.658H4.53125C6.58109 23.2905 9.17689 24.2666 12.0011 24.2666Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76195 18.5267H22.2394C22.8291 17.5644 23.2865 16.5125 23.5873 15.3962H0.414062C0.714859 16.5125 1.17222 17.5644 1.76195 18.5267Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55863 2.1413H6.65217L5.63498 2.88029L6.02353 4.07602L5.00639 3.33704L3.98925 4.07602L4.32487 3.04304C3.42928 3.78905 2.64431 4.66308 1.99744 5.63696H2.34783L1.70034 6.10735C1.59947 6.27563 1.50272 6.44658 1.41 6.62007L1.71919 7.57168L1.14234 7.15257C0.998953 7.45637 0.867797 7.76701 0.749906 8.08412L1.09055 9.13262H2.34783L1.33064 9.8716L1.71919 11.0673L0.702047 10.3283L0.0927656 10.771C0.0317812 11.2613 0 11.7606 0 12.2673H12C12 5.63996 12 4.85865 12 0.267334C9.62944 0.267334 7.41961 0.95499 5.55863 2.1413ZM6.02353 11.0673L5.00639 10.3283L3.98925 11.0673L4.3778 9.8716L3.36061 9.13262H4.61789L5.00639 7.93688L5.39489 9.13262H6.65217L5.63498 9.8716L6.02353 11.0673ZM5.63498 6.37594L6.02353 7.57168L5.00639 6.83269L3.98925 7.57168L4.3778 6.37594L3.36061 5.63696H4.61789L5.00639 4.44122L5.39489 5.63696H6.65217L5.63498 6.37594ZM10.3279 11.0673L9.31073 10.3283L8.29359 11.0673L8.68214 9.8716L7.66495 9.13262H8.92223L9.31073 7.93688L9.69923 9.13262H10.9565L9.93933 9.8716L10.3279 11.0673ZM9.93933 6.37594L10.3279 7.57168L9.31073 6.83269L8.29359 7.57168L8.68214 6.37594L7.66495 5.63696H8.92223L9.31073 4.44122L9.69923 5.63696H10.9565L9.93933 6.37594ZM9.93933 2.88029L10.3279 4.07602L9.31073 3.33704L8.29359 4.07602L8.68214 2.88029L7.66495 2.1413H8.92223L9.31073 0.945568L9.69923 2.1413H10.9565L9.93933 2.88029Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/USD.e9a3d456b20fe2f1affc8137045b4a31.svg";